import React, {useContext, useEffect} from 'react';
import CommandsContext from '../../../context/commandsContext';
import useKeyPress from '../../../hooks/useKeyPress';
import BodyContentView from '../../views/bodyContentView';

function RebootTransmitter({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const rightPress = useKeyPress('ArrowRight');
  const {onUpdateCommands} = useContext(CommandsContext);

  useEffect(() => {
    if (!leftPress) return;
    onExit();
  }, [leftPress]);

  useEffect(() => {
    if (!rightPress) return;

    onExit();
  }, [rightPress]);

  useEffect(() => {
    setTimeout(() => {
      onUpdateCommands({onLeft: onExit, onRight: onExit});
    });
  }, [onExit]);

  return (
    <BodyContentView
      title="Reboot Transmitter"
      left="No"
      right="Yes"
      caption="Do you want to reboot the transmitter?  It will go offline for approximately 10 seconds."
    />
  );
}

export default RebootTransmitter;
